// crypto.randomUUID is only available from Safari 15.4,
// if we remove support for older browsers everywhere we can sunset the polyfill
const uuidv4 = window.crypto?.randomUUID?.bind(crypto) ??
    (() => "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16)));
const validateUUID = (uuid) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);

export { uuidv4, validateUUID };
//# sourceMappingURL=uuid.js.map
